import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { Text, useTheme } from '@querodelivery/uni-react';
import { MissionChangeLogItem } from '../mission-change-log-item/mission-change-log-item';
import styles from './mission-change-log.module.scss';
import type { MissionChangeLog as MissionChangeLogType } from '../../types';

interface MissionChangeLogProps {
  changeLog: MissionChangeLogType[];
}

export const MissionChangeLog = ({ changeLog }: MissionChangeLogProps) => {
  const { color } = useTheme();

  if (!changeLog.length) return null;

  const orderedChangeLog = [...changeLog].reverse();

  return (
    <div className={styles.container}>
      <div className={styles.titleRow}>
        <FontAwesomeIcon
          icon={faClockRotateLeft}
          height={18}
          color={color['color-text-primary']}
        />
        <Text fontWeight="bold" tone="base" fontSize="lg">
          Histórico de alterações
        </Text>
      </div>
      {orderedChangeLog.map((entry, index) => (
        <MissionChangeLogItem
          key={index}
          entry={entry}
          isLast={index === orderedChangeLog.length - 1}
        />
      ))}
    </div>
  );
};
